// backoffice/src/redux/slices/planning/planningSlice.js
import { createSlice } from '@reduxjs/toolkit';
// Importer TOUS les thunks depuis le fichier séparé
import {
  fetchCycles, createCycle, updateCycle, deleteCycle,
  fetchPublicHolidays, createPublicHoliday, updatePublicHoliday, deletePublicHoliday,
  fetchDelegateLeaves, createDelegateLeave, updateDelegateLeave, deleteDelegateLeave, fetchCyclesByDelegate
} from './planningThunks'; // Import local

const initialState = {
  cycles: [],
  publicHolidays: [],
  delegateLeaves: [],
  loading: {
    cycles: false,
    publicHolidays: false,
    delegateLeaves: false,
  },
  error: null,
  cyclesByDelegate: {
    list: [],
    loading: false,
    error: null,
  },
  
};

const planningSlice = createSlice({
  name: 'planning',
  initialState,
  reducers: {
    clearPlanningError(state) {
      state.error = null;
    },
    // autres reducers synchrones...
  },
  extraReducers: (builder) => {
    builder
      // --- Cycles Reducers ---
      .addCase(fetchCycles.pending, (state) => { state.loading.cycles = true; state.error = null; })
      .addCase(fetchCycles.fulfilled, (state, action) => { state.loading.cycles = false; state.cycles = action.payload; })
      .addCase(fetchCycles.rejected, (state, action) => { state.loading.cycles = false; state.error = action.payload; })
      .addCase(createCycle.fulfilled, (state, action) => { state.cycles.unshift(action.payload); })
      .addCase(updateCycle.fulfilled, (state, action) => {
        const index = state.cycles.findIndex(c => c.id === action.payload.id);
        if (index !== -1) state.cycles[index] = action.payload;
      })
      .addCase(deleteCycle.fulfilled, (state, action) => {
        state.cycles = state.cycles.filter(c => c.id !== action.payload);
      })

      // --- Public Holidays Reducers ---
      .addCase(fetchPublicHolidays.pending, (state) => { state.loading.publicHolidays = true; state.error = null; })
      .addCase(fetchPublicHolidays.fulfilled, (state, action) => { state.loading.publicHolidays = false; state.publicHolidays = action.payload; })
      .addCase(fetchPublicHolidays.rejected, (state, action) => { state.loading.publicHolidays = false; state.error = action.payload; })
      .addCase(createPublicHoliday.fulfilled, (state, action) => {
        state.publicHolidays.push(action.payload);
        state.publicHolidays.sort((a, b) => new Date(a.date) - new Date(b.date));
      })
      .addCase(updatePublicHoliday.fulfilled, (state, action) => {
        const index = state.publicHolidays.findIndex(h => h.id === action.payload.id);
        if (index !== -1) {
           state.publicHolidays[index] = action.payload;
           state.publicHolidays.sort((a, b) => new Date(a.date) - new Date(b.date));
        }
      })
      .addCase(deletePublicHoliday.fulfilled, (state, action) => {
        state.publicHolidays = state.publicHolidays.filter(h => h.id !== action.payload);
      })

      // --- Delegate Leaves Reducers ---
      .addCase(fetchDelegateLeaves.pending, (state) => { state.loading.delegateLeaves = true; state.error = null; })
      .addCase(fetchDelegateLeaves.fulfilled, (state, action) => { state.loading.delegateLeaves = false; state.delegateLeaves = action.payload; })
      .addCase(fetchDelegateLeaves.rejected, (state, action) => { state.loading.delegateLeaves = false; state.error = action.payload; })
      .addCase(createDelegateLeave.fulfilled, (state, action) => { state.delegateLeaves.unshift(action.payload); })
      .addCase(updateDelegateLeave.fulfilled, (state, action) => {
        const index = state.delegateLeaves.findIndex(l => l.id === action.payload.id);
        if (index !== -1) state.delegateLeaves[index] = action.payload;
      })
      .addCase(deleteDelegateLeave.fulfilled, (state, action) => {
        state.delegateLeaves = state.delegateLeaves.filter(l => l.id !== action.payload);
      })

       .addCase(fetchCyclesByDelegate.pending, (state) => {
        state.cyclesByDelegate.loading = true;
        state.cyclesByDelegate.error = null;
      })
      .addCase(fetchCyclesByDelegate.fulfilled, (state, action) => {
        state.cyclesByDelegate.loading = false;
        state.cyclesByDelegate.list = action.payload;
      })
      .addCase(fetchCyclesByDelegate.rejected, (state, action) => {
        state.cyclesByDelegate.loading = false;
        state.cyclesByDelegate.error = action.payload;
      });
      ;
  },
});

export const { clearPlanningError } = planningSlice.actions;
export default planningSlice.reducer;